import { render } from "./MapEditBounds.vue?vue&type=template&id=a5f1b060&scoped=true&bindings={\"latitude\":\"props\",\"longitude\":\"props\",\"initBounds\":\"props\",\"initZoom\":\"props\",\"bounds\":\"data\",\"cancel\":\"options\",\"save\":\"options\"}"
import script from "./MapEditBounds.vue?vue&type=script&lang=js"
export * from "./MapEditBounds.vue?vue&type=script&lang=js"

import "./MapEditBounds.vue?vue&type=style&index=0&id=a5f1b060&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a5f1b060"

export default script